import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';
import {Table} from '@devexpress/dx-react-grid-material-ui';
import {withStyles} from '@material-ui/core/styles';

const styles = ({
  cell: {
    textTransform: 'capitalize'
  }
});

const propTypes = {
  row: PropTypes.object.isRequired,
};

const WholesaleTypeCell = ({intl, row, classes, ...other}) =>  {
  let types = [];

  if (row.wholesale.pickup)
    types.push('pickup');

  if (row.wholesale.delivery)
    types.push('delivery');

  return (
    <Table.Cell {...other}>
      <span className={classes.cell}>{types.join(' & ')}</span>
    </Table.Cell>
  );
};

WholesaleTypeCell.propTypes = propTypes;

export default withStyles(styles)(
  injectIntl(WholesaleTypeCell)
);
